/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllSourcesResponse } from './FindAllSourcesResponse';
import {
    FindAllSourcesResponseFromJSON,
    FindAllSourcesResponseFromJSONTyped,
    FindAllSourcesResponseToJSON,
    FindAllSourcesResponseToJSONTyped,
} from './FindAllSourcesResponse';

/**
 * 
 * @export
 * @interface FindAllScreenerSources200Response
 */
export interface FindAllScreenerSources200Response {
    /**
     * 
     */
    data?: FindAllSourcesResponse;
}

/**
 * Check if a given object implements the FindAllScreenerSources200Response interface.
 */
export function instanceOfFindAllScreenerSources200Response(value: object): value is FindAllScreenerSources200Response {
    return true;
}

export function FindAllScreenerSources200ResponseFromJSON(json: any): FindAllScreenerSources200Response {
    return FindAllScreenerSources200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerSources200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllSourcesResponseFromJSON(json['data']),
    };
}

export function FindAllScreenerSources200ResponseToJSON(json: any): FindAllScreenerSources200Response {
    return FindAllScreenerSources200ResponseToJSONTyped(json, false);
}

export function FindAllScreenerSources200ResponseToJSONTyped(value?: FindAllScreenerSources200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllSourcesResponseToJSON(value['data']),
    };
}

